module.exports = __webpack_public_path__ + "img/ico_partner.b62c47ef.svg";